module.exports = __webpack_public_path__ + "1ab05b965f34117199e50316ef3d6376.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sutter_health_2023_chart.png
// module id = 1725
// module chunks = 0